var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrYearlyOperations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d",
    x1: 73.9,
    y1: 42.5,
    x2: 91.9,
    y2: 42.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d",
    x1: 103,
    y1: 98.1,
    x2: 115.4,
    y2: 98.1,
    xlinkHref: "#SVGID_0_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d",
    x1: 145.4,
    y1: 98.1,
    x2: 157.7,
    y2: 98.1,
    xlinkHref: "#SVGID_0_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d",
    x1: 131.3,
    y1: 98.1,
    x2: 143.7,
    y2: 98.1,
    xlinkHref: "#SVGID_0_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d",
    x1: 117.3,
    y1: 98.1,
    x2: 129.6,
    y2: 98.1,
    xlinkHref: "#SVGID_0_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d",
    x1: 107.9,
    y1: 111.7,
    x2: 153.9,
    y2: 111.7,
    xlinkHref: "#SVGID_0_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d",
    x1: -81.3,
    y1: 253.5,
    x2: -58.8,
    y2: 253.5,
    gradientTransform: "rotate(20.5 579.594 560.227)",
    xlinkHref: "#SVGID_0_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d",
    y1: 75.6,
    y2: 75.6,
    xlinkHref: "#SVGID_0_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d",
    x1: -69.7,
    y1: 284.5,
    x2: -47.3,
    y2: 284.5,
    gradientTransform: "rotate(20.5 579.594 560.227)",
    xlinkHref: "#SVGID_0_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d",
    x1: 67,
    y1: 111.7,
    x2: 89.5,
    y2: 111.7,
    xlinkHref: "#SVGID_0_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M101.2 46.3h29.6M101.2 78.6h29.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d)",
    d: "M75.1 43.5l4.8 6.1 10.8-14.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M142 99.3V26.4c0-2.9-2.1-5.2-4.7-5.2H59.1c-2.6 0-4.7 2.4-4.7 5.2v102.5c0 2.9 2.1 5.2 4.7 5.2h42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M101.2 99.2h59.3v42.2h-59.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1 MI_4L_gradient",
    d: "M104.3 98.5c0-2.7 2.2-4.9 4.9-4.9s4.9 2.2 4.9 4.9v4.1",
    stroke: "url(#SVGID_1_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0 MI_4L_gradient",
    d: "M146.6 98.5c0-2.7 2.2-4.9 4.9-4.9s4.9 2.2 4.9 4.9v4.1",
    stroke: "url(#SVGID_2_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5 MI_4L_gradient",
    d: "M132.6 98.5c0-2.7 2.2-4.9 4.9-4.9s4.9 2.2 4.9 4.9v4.1",
    stroke: "url(#SVGID_3_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4 MI_4L_gradient",
    d: "M118.5 98.5c0-2.7 2.2-4.9 4.9-4.9s4.9 2.2 4.9 4.9v4.1",
    stroke: "url(#SVGID_4_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M109.1 122.4h43.8M123.6 111.7v22.4M138.3 111.7v22.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3 MI_4L_gradient",
    stroke: "url(#SVGID_5_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d)",
    d: "M109.1 111.7h43.6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M152.9 134.2h-44v-26.9h44v26.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6 MI_4L_gradient",
    d: "M87.9 49c-1.9 5.2-7.7 7.8-12.8 5.9s-7.8-7.7-5.9-12.8 7.7-7.8 12.8-5.9",
    stroke: "url(#SVGID_6_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2 MI_4L_gradient",
    stroke: "url(#SVGID_7_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d)",
    d: "M75.1 76.6l4.8 6.1 10.8-14.1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7 MI_4L_gradient",
    d: "M87.9 82.1c-1.9 5.2-7.7 7.8-12.8 5.9s-7.8-7.7-5.9-12.8 7.7-7.8 12.8-5.9",
    stroke: "url(#SVGID_8_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st8 MI_4L_gradient",
    cx: 78.3,
    cy: 111.7,
    r: 10,
    stroke: "url(#SVGID_9_d61076bbb9a6714f994371e2b4385fb1ca517016f0ce9cecf4b849d63e6cee0d)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrYearlyOperations);
export default __webpack_public_path__ + "static/media/prYearlyOperations.6cfc4bab394ec13edd837c427c97fce3.svg";
export { ForwardRef as ReactComponent };